"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_PADDING = exports.DEFAULT_FONT_SIZE = exports.DEFAULT_HEIGHT = exports.KEYCODE_ESCAPE = exports.KEYCODE_ENTER = exports.KEYCODE_DOWN = exports.KEYCODE_UP = exports.KEYCODE_R = exports.KEYCODE_S = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _lodash = _interopRequireDefault(require("lodash"));

var _CopyButton = _interopRequireDefault(require("../button/CopyButton"));

var _LoadingIndicator = _interopRequireDefault(require("../effect/LoadingIndicator"));

var _Token = _interopRequireDefault(require("./Token"));

var _providers = require("../../toolkit/providers");

var _styling = require("../../toolkit/styling");

var _async = require("../../toolkit/async");

var _icons = require("../../toolkit/icons");

var _device = require("../../toolkit/device");

var _Input = _interopRequireDefault(require("./Input"));

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (_e) { function e(_x4) { return _e.apply(this, arguments); } e.toString = function () { return _e.toString(); }; return e; }(function (e) { throw e; }), f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function (_e2) { function e(_x5) { return _e2.apply(this, arguments); } e.toString = function () { return _e2.toString(); }; return e; }(function (e) { didErr = true; err = e; }), f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var KEYCODE_S = 83;
exports.KEYCODE_S = KEYCODE_S;
var KEYCODE_R = 82;
exports.KEYCODE_R = KEYCODE_R;
var KEYCODE_UP = 38;
exports.KEYCODE_UP = KEYCODE_UP;
var KEYCODE_DOWN = 40;
exports.KEYCODE_DOWN = KEYCODE_DOWN;
var KEYCODE_ENTER = 13;
exports.KEYCODE_ENTER = KEYCODE_ENTER;
var KEYCODE_ESCAPE = 27;
exports.KEYCODE_ESCAPE = KEYCODE_ESCAPE;
var DEFAULT_HEIGHT = 40;
exports.DEFAULT_HEIGHT = DEFAULT_HEIGHT;
var DEFAULT_FONT_SIZE = 14;
exports.DEFAULT_FONT_SIZE = DEFAULT_FONT_SIZE;
var DEFAULT_PADDING = 9;
exports.DEFAULT_PADDING = DEFAULT_PADDING;

var TextInput = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TextInput, _Component);

  var _super = _createSuper(TextInput);

  // String are not used for users, just documentation.

  /* eslint-disable local-rules/unwrapped-i18n */
  function TextInput(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TextInput);
    _this = _super.call(this, props);
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "hasFocus", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "lastText", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "displayInputState", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "validationResponse", _descriptor4, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "validating", _descriptor5, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "editMade", _descriptor6, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "tokens", _descriptor7, (0, _assertThisInitialized2["default"])(_this));
    _this.mounted = false;
    _this.datalistId = void 0;
    _this.ref = null;
    _this.disposables = [];

    _this.stringify = function (value) {
      if (typeof value == "number") {
        return value.toString();
      }

      return value || "";
    };

    (0, _initializerDefineProperty2["default"])(_this, "onBlur", _descriptor8, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onFocus", _descriptor9, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onChange", _descriptor10, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onTextAreaChange", _descriptor11, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onKeyup", _descriptor12, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onKeydown", _descriptor13, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onPaste", _descriptor14, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onTextChange", _descriptor15, (0, _assertThisInitialized2["default"])(_this));
    var _this$props = _this.props,
        _value = _this$props.value,
        defaultValue = _this$props.defaultValue;
    _this.lastText = typeof defaultValue == "string" ? defaultValue : _this.stringify(_value);

    if (_value != null) {
      _this.validate();
    }

    _this.mounted = true;

    _this.generateTokens();

    _this.datalistId = _lodash["default"].uniqueId();
    (0, _mobx.reaction)( // Mobx needs to track the read from this.props in order to trigger
    // the reaction when it changes.
    // eslint-disable-next-line  react/destructuring-assignment
    function () {
      return _this.props.forceValidation;
    }, function (forceValidation) {
      if (forceValidation) {
        _this.validate();
      }
    }, {
      fireImmediately: false
    });
    return _this;
  }

  (0, _createClass2["default"])(TextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var ref = this.ref,
          disposables = this.disposables,
          _this$props2 = this.props,
          focusOnMount = _this$props2.focusOnMount,
          onTokensChanged = _this$props2.onTokensChanged;

      if (focusOnMount && ref != null) {
        setTimeout(function () {
          return _this2.acquireFocus();
        }, 500);
      }

      disposables.push((0, _mobx.reaction)( // eslint-disable-next-line react/destructuring-assignment
      function () {
        return [_this2.props.value];
      }, function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
            text = _ref2[0];

        (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(_this2.text != _this2.lastText && _this2.displayInputState)) {
                    _context.next = 4;
                    break;
                  }

                  _this2.generateTokens();

                  _context.next = 4;
                  return _this2.onTextChange(_this2.stringify(text));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }));
      disposables.push((0, _mobx.reaction)(function () {
        return [_this2.isValid, _this2.validationResponse];
      }, function (_ref4) {
        var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
            isValid = _ref5[0],
            validationResponse = _ref5[1];

        var onValidityChanged = _this2.props.onValidityChanged;

        if (onValidityChanged) {
          onValidityChanged(!!isValid, validationResponse);
        }
      }));
      disposables.push((0, _mobx.reaction)(function () {
        return [_this2.tokens.map(function (_) {
          return _;
        })];
      }, // to trigger reaction
      function (_ref6) {
        var _ref7 = (0, _slicedToArray2["default"])(_ref6, 1),
            tokens = _ref7[0];

        if (onTokensChanged) {
          onTokensChanged({
            tokens: tokens
          });
        }
      }, {
        fireImmediately: true
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var disposables = this.disposables;
      disposables.forEach(function (dispose) {
        return dispose();
      });
      this.disposables = [];
    }
  }, {
    key: "acquireFocus",
    value: function acquireFocus() {
      var ref = this.ref;

      if (ref) {
        ref.focus();
      }
    }
  }, {
    key: "validateText",
    value: function () {
      var _validateText = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(text) {
        var validators, _iterator, _step, validator, response;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                validators = this.props.validators;

                if (!(validators == null)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", null);

              case 3:
                _iterator = _createForOfIteratorHelper(validators);
                _context2.prev = 4;

                _iterator.s();

              case 6:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 17;
                  break;
                }

                validator = _step.value;

                if (validator) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("continue", 15);

              case 10:
                _context2.next = 12;
                return validator.validate(text);

              case 12:
                response = _context2.sent;

                if (!(response != null)) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return", response);

              case 15:
                _context2.next = 6;
                break;

              case 17:
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](4);

                _iterator.e(_context2.t0);

              case 22:
                _context2.prev = 22;

                _iterator.f();

                return _context2.finish(22);

              case 25:
                return _context2.abrupt("return", null);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 19, 22, 25]]);
      }));

      function validateText(_x) {
        return _validateText.apply(this, arguments);
      }

      return validateText;
    }()
  }, {
    key: "generateTokens",
    value: function generateTokens() {
      var noDuplicateTokens = this.props.noDuplicateTokens;
      var text = this.text,
          _this$props3 = this.props,
          tokenize = _this$props3.tokenize,
          _this$props3$tokenSep = _this$props3.tokenSeparator,
          tokenSeparator = _this$props3$tokenSep === void 0 ? "," : _this$props3$tokenSep;

      if (!tokenize) {
        return;
      }

      var trimmedText = this.stringify(text);

      if (trimmedText.trim().length === 0) {
        this.tokens = [];
        return;
      }

      var trimmedTokens = trimmedText.split(tokenSeparator).filter(function (_) {
        return _.trim().length > 0;
      });

      if (noDuplicateTokens) {
        this.tokens = Array.from(new Set(trimmedTokens));
      } else {
        this.tokens = trimmedTokens;
      }
    }
  }, {
    key: "deleteTokenAtIndex",
    value: function deleteTokenAtIndex(idx) {
      this.tokens.splice(idx, 1);
      this.onTextChange("");
      this.acquireFocus();
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this3 = this;

        var value, validationResponse;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                value = this.stringify(this.text);
                _context3.next = 3;
                return this.validateText(value);

              case 3:
                validationResponse = _context3.sent;

                if (!(this.text != value)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                this.validating = true;

                if (this.mounted) {
                  _context3.next = 9;
                  break;
                }

                return _context3.abrupt("return");

              case 9:
                (0, _mobx.runInAction)(function () {
                  _this3.validating = false;
                  _this3.displayInputState = true;
                  _this3.validationResponse = validationResponse;
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "renderError",
    value: function renderError() {
      var validationResponseCalculated = this.validationResponse,
          _this$props4 = this.props,
          showErrorMessages = _this$props4.showErrorMessages,
          renderBlankError = _this$props4.renderBlankError,
          validationResponseProp = _this$props4.validationResponse; // override calculated response with passed in response if one exists

      var validationResponse = validationResponseProp || validationResponseCalculated;

      if (!validationResponse && !renderBlankError || !showErrorMessages) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.errorText)
      }, validationResponse || /*#__PURE__*/_react["default"].createElement("br", null));
    }
  }, {
    key: "renderToken",
    value: function renderToken(token, idx) {
      var _this4 = this;

      return /*#__PURE__*/_react["default"].createElement(_Token["default"], {
        className: (0, _styling.css)(this.styles.token),
        key: "".concat(token, "-").concat(idx),
        onDelete: function onDelete() {
          return _this4.deleteTokenAtIndex(idx);
        }
      }, token);
    }
  }, {
    key: "renderTokens",
    value: function renderTokens() {
      var _this5 = this;

      if (this.tokens.length == 0) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.inputTokenContainer)
      }, this.tokens.map(function (token, idx) {
        return _this5.renderToken(token, idx);
      }));
    }
  }, {
    key: "renderTextArea",
    value: function renderTextArea() {
      var _this6 = this;

      var datalistId = this.datalistId;
      var _this$props5 = this.props,
          inputRef = _this$props5.inputRef,
          tokenize = _this$props5.tokenize,
          inputContainerStyle = _this$props5.inputContainerStyle,
          inputStyle = _this$props5.inputStyle,
          autoCompleteDatalist = _this$props5.autoCompleteDatalist;
      var input = null;

      if (tokenize) {
        input = /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
          className: (0, _styling.css)(this.styles.inputBase, inputStyle)
        }, this.inputProps, {
          value: this.inputText,
          onChange: this.onChange,
          placeholder: this.placeholder,
          ref: function ref(r) {
            _this6.ref = r;

            if (inputRef) {
              inputRef(r);
            }
          },
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          onKeyUp: this.onKeyup,
          onKeyDown: this.onKeydown,
          onPaste: this.onPaste,
          list: autoCompleteDatalist ? datalistId : undefined
        }));
      } else {
        input = /*#__PURE__*/_react["default"].createElement("textarea", (0, _extends2["default"])({}, this.inputProps, {
          className: (0, _styling.css)(this.styles.inputBase, this.styles.textarea, inputStyle),
          placeholder: this.placeholder,
          value: this.inputText,
          onChange: this.onTextAreaChange,
          ref: function ref(r) {
            _this6.ref = r;

            if (inputRef) {
              inputRef(r);
            }
          },
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          onKeyUp: this.onKeyup,
          onKeyDown: this.onKeydown,
          onPaste: this.onPaste
        }));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.textAreaContainer, inputContainerStyle),
        onClick: function onClick() {
          return _this6.acquireFocus();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.textAreaInner)
      }, this.tokens.map(function (token, idx) {
        return _this6.renderToken(token, idx);
      }), this.canRenderInput && input, this.renderDatalist(), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.copyButton)
      }, this.renderCopyButton())));
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this7 = this;

      var datalistId = this.datalistId;
      var _this$props6 = this.props,
          inputRef = _this$props6.inputRef,
          icon = _this$props6.icon,
          inputStyle = _this$props6.inputStyle,
          inputContainerStyle = _this$props6.inputContainerStyle,
          autoCompleteDatalist = _this$props6.autoCompleteDatalist;

      var inputProps = _objectSpread(_objectSpread({}, this.inputProps), this.inputProps.defaultValue == null ? {
        value: this.inputText
      } : {});

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.inputContainer, inputContainerStyle)
      }, icon && /*#__PURE__*/_react["default"].createElement("img", {
        src: icon,
        className: (0, _styling.css)(this.styles.icon),
        alt: "input icon",
        draggable: false
      }), this.renderTokens(), this.canRenderInput && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
        className: (0, _styling.css)(this.styles.inputBase, this.styles.input, inputStyle)
      }, inputProps, {
        placeholder: this.placeholder,
        onChange: this.onChange,
        ref: function ref(r) {
          _this7.ref = r;

          if (inputRef) {
            inputRef(r);
          }
        },
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onKeyUp: this.onKeyup,
        onKeyDown: this.onKeydown,
        onPaste: this.onPaste,
        list: autoCompleteDatalist ? datalistId : undefined
      })), this.renderDatalist()), this.renderCopyButton(), this.renderValidationFeedback());
    }
  }, {
    key: "renderDatalist",
    value: function renderDatalist() {
      var datalistId = this.datalistId,
          autoCompleteDatalist = this.props.autoCompleteDatalist;

      if (autoCompleteDatalist == null || autoCompleteDatalist.length == 0) {
        return null;
      }

      return (
        /*#__PURE__*/
        // "id" prop is need for datalist API to work
        // eslint-disable-next-line react/forbid-dom-props
        _react["default"].createElement("datalist", {
          id: datalistId
        }, autoCompleteDatalist.map(function (option) {
          return /*#__PURE__*/_react["default"].createElement("option", {
            value: option,
            key: option
          });
        }))
      );
    }
  }, {
    key: "renderValidationFeedback",
    value: function renderValidationFeedback() {
      var inputState = this.inputState,
          hasValidators = this.hasValidators,
          _this$props7 = this.props,
          disabled = _this$props7.disabled,
          validationResponseProp = _this$props7.validationResponse,
          loading = _this$props7.loading,
          hideCheckmarkWhenValid = _this$props7.hideCheckmarkWhenValid;

      if (inputState == "none" || hideCheckmarkWhenValid) {
        return null;
      }

      if (loading) {
        return /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
          type: "spinner",
          size: 16
        });
      }

      if (!hasValidators && !validationResponseProp || disabled) {
        return null;
      }

      if (this.validating) {
        return /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
          type: "spinner",
          size: 16
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.rightIcon)
      }, this.stateIcon && /*#__PURE__*/_react["default"].createElement("img", {
        src: this.stateIcon,
        style: {
          width: "100%",
          maxHeight: "100%"
        },
        draggable: false,
        alt: "validation state"
      }));
    }
  }, {
    key: "renderCopyButton",
    value: function renderCopyButton() {
      var text = this.text,
          _this$props8 = this.props,
          showCopyButton = _this$props8.showCopyButton,
          tokenize = _this$props8.tokenize,
          _this$props8$tokenSep = _this$props8.tokenSeparator,
          tokenSeparator = _this$props8$tokenSep === void 0 ? "," : _this$props8$tokenSep;
      var copyText = this.stringify(text);
      copyText = copyText.trim();

      if (tokenize && copyText.endsWith(tokenSeparator)) {
        copyText = copyText.slice(0, -1);
      }

      return /*#__PURE__*/_react["default"].createElement(_CopyButton["default"], {
        text: copyText,
        disabled: !showCopyButton,
        copyOnBodyClick: false,
        hideButtonUntilHover: false,
        popoverPosition: "left"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          isTextArea = _this$props9.isTextArea,
          className = _this$props9.className,
          renderDropdown = _this$props9.renderDropdown,
          style = _this$props9.style;
      var rootCSS = (0, _styling.css)(this.styles.root, style, className);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: rootCSS
      }, isTextArea ? this.renderTextArea() : this.renderInput(), this.renderError(), renderDropdown && renderDropdown());
    }
  }, {
    key: "inputState",
    get: function get() {
      var _this$props10 = this.props,
          validators = _this$props10.validators,
          validationResponseProp = _this$props10.validationResponse,
          hideCheckmarkWhenValid = _this$props10.hideCheckmarkWhenValid,
          loading = _this$props10.loading;

      if (validationResponseProp) {
        return "invalid";
      }

      if (!this.displayInputState || !validators) {
        return "none";
      }

      if (this.validating || loading) {
        return "pending";
      }

      if (this.isValid) {
        return hideCheckmarkWhenValid ? "none" : "valid";
      }

      return "invalid";
    }
  }, {
    key: "isValid",
    get: function get() {
      var validationResponseCalculated = this.validationResponse,
          validationResponseProp = this.props.validationResponse;
      return validationResponseProp == null && validationResponseCalculated == null;
    }
  }, {
    key: "hasValidators",
    get: function get() {
      var validators = this.props.validators;
      return validators != null && validators.filter(function (v) {
        return v != null;
      }).length > 0;
    }
  }, {
    key: "borderColor",
    get: function get() {
      var _this$context$theming = this.context.theming.theme,
          negative = _this$context$theming.negative,
          primary = _this$context$theming.primary,
          borderPrimary = _this$context$theming.borderPrimary;
      var inputState = this.inputState,
          _this$props11 = this.props,
          hideBorder = _this$props11.hideBorder,
          disabled = _this$props11.disabled,
          borderColor = _this$props11.borderColor;

      if (hideBorder) {
        return "transparent";
      }

      switch (inputState) {
        case "invalid":
          return negative;

        default:
          return this.hasFocus && !disabled ? primary : borderColor || borderPrimary;
      }
    }
  }, {
    key: "canRenderInput",
    get: function get() {
      var _this$props12 = this.props,
          tokenize = _this$props12.tokenize,
          maxTokens = _this$props12.maxTokens;

      if (tokenize) {
        if (maxTokens != null) {
          return this.tokens.length < maxTokens;
        }
      }

      return true;
    }
  }, {
    key: "stateIcon",
    get: function get() {
      var inputState = this.inputState;

      switch (inputState) {
        case "valid":
          return _icons.greenCheckmark;

        default:
          return null;
      }
    }
  }, {
    key: "inputText",
    get: function get() {
      var text = this.text,
          tokens = this.tokens,
          _this$props13 = this.props,
          tokenize = _this$props13.tokenize,
          _this$props13$tokenSe = _this$props13.tokenSeparator,
          tokenSeparator = _this$props13$tokenSe === void 0 ? "," : _this$props13$tokenSe;

      if (!tokenize) {
        return this.stringify(text);
      }

      var tokensAsString = tokens.join(tokenSeparator); // remove leading whitespace of last token

      var textTokens = this.stringify(text).split(tokenSeparator);
      textTokens[textTokens.length - 1] = textTokens[textTokens.length - 1].replace(/^\s+/g, "");
      var trimmedText = textTokens.filter(function (_) {
        return _.trim().length > 0;
      }).join(tokenSeparator);
      var difference = trimmedText.substring(tokensAsString.length);

      if (difference.startsWith(tokenSeparator)) {
        return difference.substring(1);
      }

      return difference;
    }
  }, {
    key: "text",
    get: function get() {
      var value = this.props.value;

      if (value === null) {
        return "";
      }

      if (value === undefined) {
        return this.lastText;
      }

      return value;
    }
  }, {
    key: "placeholder",
    get: function get() {
      var _this$props14 = this.props,
          placeholder = _this$props14.placeholder,
          tokenize = _this$props14.tokenize;

      if (tokenize && this.tokens.length > 0) {
        return undefined;
      }

      return placeholder || undefined;
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming2 = this.context.theming,
          _this$context$theming3 = _this$context$theming2.theme,
          surfaceLight = _this$context$theming3.surfaceLight,
          inputBackground = _this$context$theming3.inputBackground,
          negative = _this$context$theming3.negative,
          textDark = _this$context$theming3.textDark,
          textBlack = _this$context$theming3.textBlack,
          textPlaceholder = _this$context$theming3.textPlaceholder,
          fonts = _this$context$theming2.fonts;
      var _this$props15 = this.props,
          icon = _this$props15.icon,
          disabled = _this$props15.disabled,
          hideBorder = _this$props15.hideBorder,
          verticalPadding = _this$props15.verticalPadding,
          canResize = _this$props15.canResize,
          tokenize = _this$props15.tokenize,
          rows = _this$props15.rows,
          _this$props15$borderR = _this$props15.borderRadius,
          borderRadius = _this$props15$borderR === void 0 ? 4 : _this$props15$borderR,
          heightProp = _this$props15.height,
          _this$props15$padding = _this$props15.padding,
          padding = _this$props15$padding === void 0 ? DEFAULT_PADDING : _this$props15$padding,
          _this$props15$fontSiz = _this$props15.fontSize,
          fontSize = _this$props15$fontSiz === void 0 ? DEFAULT_FONT_SIZE : _this$props15$fontSiz;
      var height = heightProp === undefined ? DEFAULT_HEIGHT : heightProp;
      var hasIcon = !!icon;
      var iconKeyframes = {
        from: {
          transform: "scale(0, 0)",
          opacity: 0.5
        },
        to: {
          transform: "scale(1, 1)",
          opacity: 1
        }
      };
      var errorKeyframes = {
        from: {
          transform: "translateY(-5px)",
          opacity: 0
        },
        to: {
          transform: "translate(-5px)",
          opacity: 1
        }
      };

      var _DeviceStore$instance = _device.DeviceStore.instance(),
          isFirefox = _DeviceStore$instance.isFirefox;

      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          position: "relative"
        },
        inputContainer: {
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          padding: verticalPadding ? padding : "0px ".concat(padding, "px"),
          border: !hideBorder ? "solid 1px ".concat(this.borderColor) : undefined,
          borderRadius: borderRadius,
          backgroundColor: disabled ? surfaceLight : inputBackground,
          opacity: disabled ? 0.5 : 1,
          overflowX: "auto",
          overflowY: "hidden",
          height: height,
          position: "relative"
        },
        textAreaContainer: {
          padding: padding,
          border: !hideBorder ? "solid 1px ".concat(this.borderColor) : undefined,
          borderRadius: !hideBorder ? 4 : undefined,
          backgroundColor: disabled ? surfaceLight : inputBackground,
          opacity: disabled ? 0.5 : 1,
          overflowX: "auto",
          overflowY: tokenize ? "auto" : "hidden",
          height: !rows ? height : undefined
        },
        textAreaInner: {
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "row",
          flexWrap: "wrap",
          ":nth-child(1n) > *": {
            margin: "3px 4px 3px 4px",
            flexBasis: 0,
            flexShrink: 0
          }
        },
        icon: {
          opacity: 0.6,
          marginRight: 7,
          width: 16,
          height: 16
        },
        inputBase: {
          fontSize: fontSize,
          fontFamily: fonts.regular,
          color: textBlack,
          border: "none",
          ":focus": {
            outline: "none",
            borderColor: "none",
            boxShadow: "none"
          },
          ":disabled": {
            backgroundColor: surfaceLight
          },
          "::placeholder": {
            color: textPlaceholder
          },
          margin: 0,
          padding: "0px 5px",
          flex: 1,
          backgroundColor: "transparent"
        },
        input: {
          height: height,
          flex: isFirefox ? "1 1 auto" : 1,
          width: isFirefox ? "90%" : "100%",
          alignSelf: "stretch",
          padding: "0px 0px 0px ".concat(hasIcon ? 0 : padding, "px")
        },
        textarea: {
          padding: 0,
          margin: 0,
          flex: 1,
          alignSelf: "stretch",
          resize: canResize ? "auto" : "none",
          boxShadow: "none",
          // Needed to allow "cols" to work
          // eslint-disable-next-line local-rules/no-complex-styling
          width: "auto"
        },
        rightIcon: {
          width: 16,
          height: 16,
          animationName: [iconKeyframes],
          animationDuration: "400ms",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px 3px"
        },
        errorText: {
          fontSize: 12,
          fontFamily: fonts.semibold,
          lineHeight: 1.33,
          color: negative,
          marginTop: 7,
          animationName: [errorKeyframes],
          animationDuration: "300ms",
          cursor: "default"
        },
        inputTokenContainer: {
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          ":nth-child(1n) > *": {
            margin: "0px 7px 0px 7px",
            flexBasis: 0,
            flexShrink: 0
          }
        },
        token: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "#cef2fd",
          padding: "2px 8px",
          maxHeight: "90%",
          fontSize: fontSize,
          fontFamily: fonts.regular,
          cursor: "pointer",
          borderRadius: 3,
          transition: "opacity 0.3s linear",
          whiteSpace: "nowrap",
          opacity: 0.9,
          ":hover": {
            opacity: 1
          }
        },
        tokenDelete: {
          color: textDark,
          marginLeft: 8
        },
        copyButton: {
          position: "absolute",
          bottom: padding,
          right: padding
        }
      });
    }
  }, {
    key: "inputProps",
    get: function get() {
      var _this$props16 = this.props,
          inputRef = _this$props16.inputRef,
          icon = _this$props16.icon,
          onChange = _this$props16.onChange,
          validators = _this$props16.validators,
          className = _this$props16.className,
          style = _this$props16.style,
          focusOnMount = _this$props16.focusOnMount,
          onValidityChanged = _this$props16.onValidityChanged,
          showErrorMessages = _this$props16.showErrorMessages,
          hideCheckmarkWhenValid = _this$props16.hideCheckmarkWhenValid,
          hideBorder = _this$props16.hideBorder,
          passValidity = _this$props16.passValidity,
          isTextArea = _this$props16.isTextArea,
          padding = _this$props16.padding,
          verticalPadding = _this$props16.verticalPadding,
          maxTokens = _this$props16.maxTokens,
          tokenize = _this$props16.tokenize,
          height = _this$props16.height,
          inputContainerStyle = _this$props16.inputContainerStyle,
          debugValue = _this$props16.debugValue,
          renderDropdown = _this$props16.renderDropdown,
          noDuplicateTokens = _this$props16.noDuplicateTokens,
          showCopyButton = _this$props16.showCopyButton,
          onTokensChanged = _this$props16.onTokensChanged,
          inputStyle = _this$props16.inputStyle,
          borderRadius = _this$props16.borderRadius,
          value = _this$props16.value,
          onKeyUp = _this$props16.onKeyUp,
          loading = _this$props16.loading,
          validationResponse = _this$props16.validationResponse,
          autoCompleteDatalist = _this$props16.autoCompleteDatalist,
          forceValidation = _this$props16.forceValidation,
          inputProps = (0, _objectWithoutProperties2["default"])(_this$props16, ["inputRef", "icon", "onChange", "validators", "className", "style", "focusOnMount", "onValidityChanged", "showErrorMessages", "hideCheckmarkWhenValid", "hideBorder", "passValidity", "isTextArea", "padding", "verticalPadding", "maxTokens", "tokenize", "height", "inputContainerStyle", "debugValue", "renderDropdown", "noDuplicateTokens", "showCopyButton", "onTokensChanged", "inputStyle", "borderRadius", "value", "onKeyUp", "loading", "validationResponse", "autoCompleteDatalist", "forceValidation"]);
      return inputProps;
    }
  }]);
  return TextInput;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  icon: {
    required: false,
    defaultValue: "null",
    type: "(string | null)",
    description: "Icon url for the input. Placed to the left of the text"
  },
  onBlur: {
    required: false,
    defaultValue: "null",
    type: "(e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void",
    description: "Callback for when the input looses focus"
  },
  padding: {
    required: false,
    defaultValue: "".concat(DEFAULT_PADDING, "px"),
    type: "number",
    description: "Internal padding of the input"
  },
  verticalPadding: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "The `padding` also apply to top and bottom"
  },
  height: {
    required: false,
    defaultValue: "".concat(DEFAULT_HEIGHT, "px"),
    type: "number | (string | null)",
    description: "Use to control the height of the input." + " It's ignored if `isTextArea` is true and `rows` is specified"
  },
  onFocus: {
    required: false,
    defaultValue: "null",
    type: "(e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void",
    description: "Callback for when the input receives focus"
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates if the input is disabled. Set to true when " + "submitting a data to API"
  },
  onChange: {
    required: false,
    defaultValue: "null",
    type: "(event: OnTextChangeEvent) => unknown",
    description: "Callback for when the input value changes"
  },
  passValidity: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Tells the input to pass its validity in the onChange callback " + "(will slow down TextInput if validators are slow)"
  },
  onValidityChanged: {
    required: false,
    defaultValue: "null",
    type: "(isValid: boolean, errorMessage: (string | null)) => unknown",
    description: "Callback for when the validity of the input changes"
  },
  validators: {
    required: false,
    defaultValue: "null",
    type: "ReadonlyArray<Validator>",
    description: "Optional list of `Validator`s for the input." + " Validators determine if the input is correct and display " + "error messages to the user"
  },
  focusOnMount: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Tells the input to acquire focus immediately after it loads"
  },
  hideCheckmarkWhenValid: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Tells the input to display green checkmark when the " + "input is valid"
  },
  showErrorMessages: {
    required: false,
    defaultValue: "true",
    type: "boolean",
    description: "Tells the input to display error messages from the validators"
  },
  hideBorder: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Tells the input to hide its border"
  },
  borderColor: {
    required: false,
    defaultValue: undefined,
    type: "string",
    description: "Color of the border when no error"
  },
  isTextArea: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the input is a textarea"
  },
  canResize: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the input can be resized, " + "only works if isTextArea is true"
  },
  tokenize: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the input displayed as token items"
  },
  noDuplicateTokens: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Whether the user can enter duplicate tokens"
  },
  maxTokens: {
    required: false,
    defaultValue: "null",
    type: "number",
    description: "Maximum number of tokens allowed to be entered. " + "Will stop accepting input after this"
  },
  tokenSeparator: {
    required: false,
    defaultValue: ",",
    type: "string",
    description: "What separates the tokens."
  },
  renderDropdown: {
    required: false,
    defaultValue: "null",
    type: "(() => ReactNode)",
    description: "Renders a dropdown below the input."
  },
  debugValue: {
    required: false,
    defaultValue: "null",
    type: "(string | null)",
    description: "in a development environment, prefill the input with this" + "value if \"Enter\" is pressed while the input is empty. Used for quick " + "debugging ang testing"
  },
  inputStyle: {
    required: false,
    defaultValue: "null",
    type: "CSSStyleDeclaration",
    description: "Additional stylesheet for its input element " + "that adds or overwrites style attributes"
  },
  inputContainerStyle: {
    required: false,
    defaultValue: "null",
    type: "CSSStyleDeclaration",
    description: "Additional stylesheet for its input container" + "that adds or overwrites style attributes"
  },
  borderRadius: {
    required: false,
    defaultValue: "4",
    type: "number",
    description: "Border radius of the text input"
  },
  loading: {
    required: false,
    defaultValue: "null",
    type: "boolean",
    description: "external control for validation loading indicator"
  },
  forceValidation: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Turn on when the user clicks 'submit' on the form. Tells the text input to " + "validate the current input to see of form is ready for submission."
  }
}, _class3.demoProps = [{
  demoDescription: "active",
  icon: _icons.search,
  placeholder: "Search for something"
}, {
  demoDescription: "textarea",
  icon: _icons.search,
  placeholder: "Search for something",
  isTextArea: true,
  rows: 5,
  cols: 40,
  height: 200
}, {
  demoDescription: "disabled",
  disabled: true,
  icon: _icons.search,
  placeholder: "Search for something"
}, {
  demoDescription: "tokenized values",
  icon: _icons.search,
  placeholder: "Search for something",
  tokenize: true,
  defaultValue: "milk,eggs,cheese,bread",
  maxTokens: 5
}, {
  demoDescription: "tokenized values w/ textarea",
  icon: _icons.search,
  placeholder: "Search for something",
  tokenize: true,
  defaultValue: "milk,eggs,cheese,bread,milk,eggs,cheese,bread,milk",
  isTextArea: true,
  maxTokens: 15,
  height: 200
}], _class3.defaultProps = {
  showErrorMessages: true
}, _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "hasFocus", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "lastText", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "displayInputState", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "validationResponse", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "validating", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "editMade", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "tokens", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "inputState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputState"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "isValid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isValid"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "hasValidators", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasValidators"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "borderColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "borderColor"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "canRenderInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canRenderInput"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "stateIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "stateIcon"), _class2.prototype), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onBlur", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;

    return /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(e) {
        var _this8$props, onBlur, tokenize;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this8$props = _this8.props, onBlur = _this8$props.onBlur, tokenize = _this8$props.tokenize;

                if (onBlur) {
                  onBlur(e);
                }

                _this8.hasFocus = false;

                if (tokenize) {
                  _this8.generateTokens();
                }

                if (!(!_this8.hasValidators || !_this8.editMade)) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return");

              case 6:
                _context4.next = 8;
                return _this8.validate();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }();
  }
}), _descriptor9 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onFocus", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;

    return function (e) {
      var onFocus = _this9.props.onFocus;
      _this9.hasFocus = true;

      if (onFocus) {
        onFocus(e);
      }
    };
  }
}), _descriptor10 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onChange", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;

    return function (e) {
      var target = e.target;
      _this10.editMade = true;

      if (target instanceof HTMLInputElement) {
        _this10.onTextChange(target.value);
      }
    };
  }
}), _descriptor11 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onTextAreaChange", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this11 = this;

    return /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(e) {
        var target;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                target = e.target;
                _this11.editMade = true;

                if (target instanceof HTMLTextAreaElement) {
                  _this11.onTextChange(target.value);
                }

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x3) {
        return _ref9.apply(this, arguments);
      };
    }();
  }
}), _descriptor12 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onKeyup", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this12 = this;

    return function (e) {
      var _this12$props = _this12.props,
          tokenize = _this12$props.tokenize,
          debugValue = _this12$props.debugValue,
          onKeyUp = _this12$props.onKeyUp;
      var keyCode = e.keyCode || e.charCode;

      if (onKeyUp) {
        onKeyUp(keyCode);
      }

      if (keyCode == KEYCODE_ENTER) {
        var isProduction = _this12.context.env == "production";

        if (!isProduction && debugValue && _this12.stringify(_this12.text).trim().length == 0) {
          _this12.onTextChange(debugValue); // Flush the event loop, generate tokens after.


          setTimeout(function () {
            return _this12.generateTokens();
          }, 0);
          return;
        }

        if (tokenize) {
          _this12.generateTokens();
        }
      }
    };
  }
}), _descriptor13 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onKeydown", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this13 = this;

    return function (e) {
      var tokenize = _this13.props.tokenize;

      if (tokenize) {
        var _keyCode = e.keyCode || e.charCode;

        if (_keyCode == 8 || _keyCode == 46) {
          // Backspaces pressed
          if (_this13.inputText.length === 0) {
            _this13.tokens.pop();

            _this13.onTextChange("");

            _this13.acquireFocus();
          }
        }
      }
    };
  }
}), _descriptor14 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onPaste", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this14 = this;

    return function () {
      var tokenize = _this14.props.tokenize;

      if (tokenize) {
        // allow text to be pasted -- flush the  event loop, then run this.
        setTimeout(function () {
          return _this14.generateTokens();
        }, 0);
      }
    };
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "inputText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputText"), _class2.prototype), _descriptor15 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onTextChange", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this15 = this;

    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
      var valueParam,
          _this15$props,
          onChange,
          passValidity,
          tokenize,
          noDuplicateTokens,
          _this15$props$tokenSe,
          tokenSeparator,
          type,
          value,
          newToken,
          text,
          textAsNumber,
          _float,
          _args6 = arguments;

      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              valueParam = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : "";
              _this15$props = _this15.props, onChange = _this15$props.onChange, passValidity = _this15$props.passValidity, tokenize = _this15$props.tokenize, noDuplicateTokens = _this15$props.noDuplicateTokens, _this15$props$tokenSe = _this15$props.tokenSeparator, tokenSeparator = _this15$props$tokenSe === void 0 ? "," : _this15$props$tokenSe, type = _this15$props.type;
              value = valueParam;

              if (tokenize) {
                if (value.endsWith(tokenSeparator)) {
                  newToken = value.replace(tokenSeparator, "").trim();

                  if (newToken.length > 0) {
                    if (!noDuplicateTokens || !_this15.tokens.includes(newToken)) {
                      _this15.tokens.push(newToken);
                    }
                  }

                  value = "";
                } else if (value === _this15.props.value) {
                  // value contains all the existing keywords.
                  value = _this15.inputText;
                }
              }

              text = [].concat((0, _toConsumableArray2["default"])(_this15.tokens), [value]).join(tokenSeparator);
              textAsNumber = undefined;

              if (type === "number") {
                _float = parseFloat(text);
                textAsNumber = isNaN(_float) ? null : _float;
              }

              if (!(text === _this15.lastText)) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return");

            case 9:
              _this15.lastText = text;

              if (onChange && !passValidity) {
                onChange({
                  text: text,
                  textAsNumber: textAsNumber
                });
              }

              if (_this15.hasValidators) {
                _context6.next = 13;
                break;
              }

              return _context6.abrupt("return");

            case 13:
              _this15.validating = true; // debounce the input: wait for things to settle do we don't
              // 1) spam validator -- usually server requests
              // 2) overwhelm the user

              _context6.next = 16;
              return (0, _async.sleep)(1000);

            case 16:
              if (!(_this15.inputText != value)) {
                _context6.next = 18;
                break;
              }

              return _context6.abrupt("return");

            case 18:
              _context6.next = 20;
              return _this15.validate();

            case 20:
              if (onChange && passValidity) {
                onChange({
                  text: text,
                  textAsNumber: textAsNumber,
                  isValid: _this15.isValid
                });
              }

            case 21:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "deleteTokenAtIndex", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "deleteTokenAtIndex"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "validate", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "validate"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "text", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "text"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "placeholder", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "placeholder"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "inputProps", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputProps"), _class2.prototype)), _class2)) || _class;

var _default = TextInput;
exports["default"] = _default;